import { render, staticRenderFns } from "./AdminTable.vue?vue&type=template&id=f392361a&scoped=true"
import script from "./AdminTable.vue?vue&type=script&lang=js"
export * from "./AdminTable.vue?vue&type=script&lang=js"
import style0 from "./AdminTable.vue?vue&type=style&index=0&id=f392361a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f392361a",
  null
  
)

export default component.exports